import { Fade } from "@mui/material";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

const CardAnimation = ({
    children,
    checked,
    id,
    style = {}
}) => {
    const { isScrollHightLight } = useSelector((state) => state.common);
    const [shouldRender, setShouldRender] = useState(false);
    const [hasError, setHasError] = useState(false);

    // Add a small delay to ensure DOM is ready
    useEffect(() => {
        if (checked) {
            const timer = setTimeout(() => {
                setShouldRender(true);
            }, 100);
            return () => clearTimeout(timer);
        } else {
            setShouldRender(false);
        }
    }, [checked]);

    // Don't render if checked is false
    if (!checked) {
        return null;
    }

    // If there was an error, render without animation
    if (hasError) {
        return (
            <div
                id={id}
                style={{
                    ...isScrollHightLight && { borderRadius: 10 },
                }}
                className={isScrollHightLight === id ? `scrollView` : null}
            >
                {children}
            </div>
        );
    }

    try {
        return (
            <Fade
                id={id}
                in={shouldRender}
                timeout={100}
                easing={{
                    enter: "cubic-bezier(0.25, 0.1, 0.25, 1)",
                }}
                style={{
                    ...isScrollHightLight && { borderRadius: 10 },
                    // ...isScrollHightLight && { border: "1px solid #92c7ff" },
                    // background: isScrollHightLight === id ? "#92c7ff" : "inherit",
                    // border: isScrollHightLight === id ? "1px solid #2259c9" : "inherit",
                    ...style
                }}
                className={isScrollHightLight === id ? `scrollView` : null}
                unmountOnExit={false}
                mountOnEnter={true}
                onError={() => setHasError(true)}
            >
                <div>
                    {children}
                </div>
            </Fade>
        );
    } catch (error) {
        console.warn('CardAnimation error:', error);
        setHasError(true);
        return (
            <div
                id={id}
                style={{
                    ...isScrollHightLight && { borderRadius: 10 },
                }}
                className={isScrollHightLight === id ? `scrollView` : null}
            >
                {children}
            </div>
        );
    }
}

export default CardAnimation